export class UnknownAPIEndpointError extends Error {
  constructor(endpointName: string) {
    super(`Unknown API endpoint: ${endpointName}`);
  }
}
